import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { API_ROUTES } from '../constants/api.routes';
import { DefaultOptionItem } from '../types/common';
import { BrandItem, DistributionTerritoryItem, MaterialGroupItem } from '../types/dashboard';

export const autocompleteAPI = createApi({
  reducerPath: 'autocompleteAPI',
  baseQuery: fetchBaseQuery({
    baseUrl: `${process.env.REACT_APP_API_URL}`,
    prepareHeaders: (headers) => {
      const token = window.localStorage.getItem('accessToken');
      if (token) {
        headers.set('Authorization', `Bearer ${token}`);
      }
      return headers;
    }
  }),
  tagTypes: [
    'Stages',
    'Types',
    'BrandGroups',
    'Brands',
    'Territories',
    'Locations',
    'MaterialGroups',
    'Materials'
  ],
  endpoints: (build) => ({
    fetchStages: build.query<DefaultOptionItem[], {}>({
      query: () => ({
        url: API_ROUTES.STAGE.ROOT
      }),
      providesTags: () => [{ type: 'Stages', id: 'LIST' }]
    }),
    fetchTypes: build.query<DefaultOptionItem[], {}>({
      query: () => ({
        url: API_ROUTES.TYPE.ROOT
      }),
      providesTags: () => [{ type: 'Types', id: 'LIST' }]
    }),
    fetchBrandGroups: build.query<DefaultOptionItem[], {}>({
      query: () => ({
        url: API_ROUTES.BRAND.GROUP
      }),
      providesTags: () => [{ type: 'BrandGroups', id: 'LIST' }]
    }),
    fetchBrands: build.query<BrandItem[], string>({
      query: (name) => ({
        url: `${API_ROUTES.BRAND.ROOT}/${name}`
      }),
      providesTags: () => [{ type: 'Brands', id: 'LIST' }]
    }),
    fetchTerritories: build.query<DistributionTerritoryItem[], {}>({
      query: () => ({
        url: API_ROUTES.TERRITORIES.ROOT
      }),
      providesTags: () => [{ type: 'Territories', id: 'LIST' }]
    }),
    fetchLocations: build.query<any, {}>({
      query: (params) => ({
        url: API_ROUTES.TERRITORIES.LOCATIONS,
        params
      }),
      providesTags: () => [{ type: 'Locations', id: 'LIST' }]
    }),
    fetchMaterialGroups: build.query<MaterialGroupItem[], {}>({
      query: () => ({
        url: API_ROUTES.MATERIALS.GROUPS
      }),
      providesTags: () => [{ type: 'MaterialGroups', id: 'LIST' }]
    }),
    fetchMaterials: build.query<any, string>({
      query: (ids) => ({
        url: API_ROUTES.MATERIALS.LISTS,
        params: {
          ids: ids
        }
      }),
      providesTags: () => [{ type: 'Materials', id: 'LIST' }]
    })
  })
});
export const {
  useFetchStagesQuery,
  useFetchTypesQuery,
  useFetchBrandGroupsQuery,
  useFetchBrandsQuery,
  useFetchTerritoriesQuery,
  useFetchLocationsQuery,
  useFetchMaterialGroupsQuery,
  useFetchMaterialsQuery
} = autocompleteAPI;
